import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import type { ConfigKey } from '@/types';

import { API_ROUTES } from '@/query/routes';
import axiosInstance from '@/utils/api/axios-instance';

const useResetMapConfig = (
  options?: UseMutationOptions<Record<ConfigKey, boolean>, Error, Record<ConfigKey, boolean>>
) => {
  return useMutation({
    mutationFn: async (config) => {
      const response = await axiosInstance.put(API_ROUTES.mapConfig, {
        mapConfig: config,
      });

      return response.data;
    },
    ...options,
  });
};

export default useResetMapConfig;
